import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a86ecaa"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"20px","font-weight":"500","color":"#000"} }, " セットSKUを確認 ", -1))
const _hoisted_2 = { style: {"margin-top":"5px"} }
const _hoisted_3 = { class: "flex-ter" }
const _hoisted_4 = {
  class: "show-two-line",
  style: {"width":"120px","text-align":"left"}
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  style: {"color":"#F5222D"}
}

import { ref, onUnmounted, onMounted, nextTick, computed } from 'vue'
import STable from '@/components/Table/index.vue'
import { shopInfoDrawerColumns, groupTableConfig, combinationColumns } from './SalesPerspectiveData'
import { t } from '@/plugins/i18n'
import { request } from '@/config/request/interceptors'
import { QueryBindGoodsRespDTO } from '@/service/apis'
import AppLink from '@/components/common/AppLink.vue'
import CopyButton from '@/components/common/CopyButton.vue'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import { isJA, useRtfix } from '@/store'
import { dayjs, ElMessageBox } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  props: ['thirdWhite'],
  setup(__props, { expose }) {

const props = __props
const visiable = ref(false)
const tableData = ref<QueryBindGoodsRespDTO[]>([])
const rowData = ref({})



const productTableConfig = {
  showSelection: false,
  setHeight: true,
  showExpand: false,
  rowKey: 'thirdSkuCode',
  showHandler: false

}

const columns = [
  {
    label: t('商品情报'),
    prop: 'productInfo',
    slotName: 'productInfo',
    minWidth: 200
  },
  {
    label: t('客户商品sku'),
    prop: 'itemRemark',
    align: 'center'
  },
  {
    label: t('产品规格'),
    prop: 'thirdItemAttribute',
    align: 'center',
    minWidth: 140
  },
  {
    label: t('关联状态'),
    prop: 'bindStatus',
    slotName: 'bindStatus',
    align: 'center'
  },
  {
    label: t('已销售数量合计'),
    prop: 'realSellQuantity',
    align: 'center'
  },
  {
    label: t('已发货数量合计'),
    prop: 'hasDeliveryQuantity',
    slotName: 'hasDeliveryQuantity',
    align: 'center',
    minWidth: 150,
    slotHeadName: 'hasDeliveryQuantityTitle'
  },
  {
    label: t('其他发货数量'),
    prop: 'offlineOutboundQuantity',
    slotName: 'offlineOutboundQuantity',
    align: 'center',
    minWidth: 140,
    slotHeadName: 'offlineOutboundQuantityTitle'
  },
  {
    label: t('未发货数量合计'),
    prop: 'notDeliveryQuantity',
    slotName: 'notDeliveryQuantity',
    align: 'center'
  }
]
const queryBindGoods = async () => {
  try {
    const res = await await request.apis.thirdShopItem.selectCombinationList({
      sku: rowData.value.itemRemark
    })
    console.log(res.data, 'res.data')
    tableData.value = res.data ?? []
    visiable.value = true
  } catch (error) {

  }
}

expose({
  show: async (row: Record<string, any>) => {
    rowData.value = row
    queryBindGoods()
  }
})


return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_HeaderTips = _resolveComponent("HeaderTips")!
  const _component_ElDrawer = _resolveComponent("ElDrawer")!

  return (_openBlock(), _createBlock(_component_ElDrawer, {
    modelValue: visiable.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((visiable).value = $event)),
    direction: "btt",
    size: "60%"
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(STable, {
            ref: (_value, _refs) => {
              _refs['productRef'] = _value
            },
            tableData: tableData.value,
            tableConfig: productTableConfig,
            showPagination: false,
            columns: columns,
            showAllExpand: false
          }, {
            productInfo: _withCtx(({ row }) => [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(ShoppingPreview, {
                    image: row.thirdItemImage || row.thirdItemImage || ''
                  }, null, 8, ["image"]),
                  _createVNode(_component_el_tooltip, { effect: "light" }, {
                    content: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(row?.thirdItemName), 1)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_4, _toDisplayString(row?.thirdItemName), 1)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ])
            ]),
            bindStatus: _withCtx(({ row }) => [
              (row.bindStatus === 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(t)('已绑定')), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(t)('未绑定')), 1))
            ]),
            hasDeliveryQuantity: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(row.bindStatus === 1 || __props.thirdWhite ? row.hasDeliveryQuantity : '-'), 1)
            ]),
            offlineOutboundQuantity: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(row.bindStatus === 1 || __props.thirdWhite ? row.offlineOutboundQuantity : '-'), 1)
            ]),
            notDeliveryQuantity: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(row.bindStatus === 1 || __props.thirdWhite ? row.notDeliveryQuantity : '-'), 1)
            ]),
            offlineOutboundQuantityTitle: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('其他发货数量')) + " ", 1),
              _createVNode(_component_HeaderTips, { content: "システムAPIを経由せずに出荷した数量です。" })
            ]),
            hasDeliveryQuantityTitle: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('已发货数量合计')) + " ", 1),
              _createVNode(_component_HeaderTips, { content: "システムAPIを経由して注文を取得し、出荷完了した数量です。" })
            ]),
            _: 1
          }, 8, ["tableData"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})